import React from "react";
import MessagingPanel from "./MessagingPanel";

const ChatModal = ({ open, onClose, title, messagingProps }) => {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/65 backdrop-blur-sm px-2 sm:px-6">
      <div className="w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col rounded-2xl border border-emerald-200 shadow-2xl bg-gradient-to-br from-slate-50 via-white to-emerald-50">
        <div className="flex items-center justify-between px-4 py-3 border-b border-emerald-100 bg-white/70 backdrop-blur">
          <p className="font-semibold text-slate-900">{title}</p>
          <button
            type="button"
            onClick={onClose}
            className="text-sm text-slate-500 hover:text-slate-800"
          >
            Close
          </button>
        </div>
        <div className="p-3 overflow-y-auto">
          <MessagingPanel
            {...messagingProps}
            containerClassName="shadow-none border border-slate-100"
            onConversationDeleted={() => {
              messagingProps?.onConversationDeleted?.();
              onClose?.();
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default ChatModal;
